import {
  FacebookShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
} from 'react-share';
import {twMerge} from 'tailwind-merge';

export function SectionShare({
  className,
  url,
}: {
  className?: string;
  url: string;
}) {
  return (
    <div className={twMerge('flex flex-wrap gap-4 items-center', className)}>
      <p className="text-sm font-bold">Compatir</p>

      <div className="flex flex-wrap gap-2">
        <FacebookShareButton url={url}>
          <span className="block py-1 px-6 text-xs text-purple-800 bg-purple-100 rounded-md">
            Facebook
          </span>
        </FacebookShareButton>
        <LinkedinShareButton url={url}>
          <span className="block py-1 px-6 text-xs text-purple-800 bg-purple-100 rounded-md">
            LinkedIn
          </span>
        </LinkedinShareButton>
        <WhatsappShareButton url={url}>
          <span className="block py-1 px-6 text-xs text-purple-800 bg-purple-100 rounded-md">
            WhatsApp
          </span>
        </WhatsappShareButton>
      </div>
    </div>
  );
}
